export default "__VITE_ASSET__71cdb7d0__"